module.exports = __webpack_public_path__ + "static/img/arduino_nano-1.8b9b934.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_nano-1.svg
// module id = Ly1O
// module chunks = 0